/** @format */
import {MouseEvent, useState} from 'react';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {Menu, useMediaQuery} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {useNavigate} from 'react-router-dom';

import {HeaderMenuButton} from 'components/buttons/HeaderMenuButton';

import {StyledMenuItem} from './styles';
import {HEADER_ROUTES} from '../constants';

interface Props {
  onClickExit: () => void;
  onClickAccount: () => void;
}

const AccountMenu = ({onClickExit, onClickAccount}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const handleOpen = (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickAccount = () => {
    handleClose();
    onClickAccount();
    navigate(HEADER_ROUTES.ACCOUNT);
  };

  const handleExit = () => {
    handleClose();
    onClickExit();
  };

  return (
    <>
      <HeaderMenuButton active={open} onClick={handleOpen}>
        <AccountCircleOutlinedIcon />
        Аккаунт
      </HeaderMenuButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: isMobile ? 'center' : 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              background: 'transparent',
              marginTop: theme.spacing(1),
            },
          },
        }}
      >
        <StyledMenuItem disableRipple onClick={handleClickAccount}>
          Настройки аккаунта
        </StyledMenuItem>
        <StyledMenuItem disableRipple onClick={handleExit}>
          <ExitToAppIcon />
          Выход
        </StyledMenuItem>
      </Menu>
    </>
  );
};

export {AccountMenu};
